<template lang="pug">
UiPage(
  :title="reseller.name"
  v-if="reseller"
)
  .container
    UiCard
      UiCardSection
        h4 {{ $t("billing.title") }}
        UiStack
          UiStack
            UiInputLabel(:shifted="false") {{ $t("billing.year_and_month") }}
          UiStackItem(
            grow
            shrink
          )
          UiStackItem(v-if="reseller")
            UiButton(
              :href="downloadLink"
              icon="Download"
              target="_blank"
            ) {{ $t("actions.download") }}
      UiCardSection
        RestTable(
          namespace="billing"
          :headers="headers"
          ref="billingTable"
          :fetchHandler="getData"
          embed
        )
          template(#filters="{ filters, updateFilters }")
            UiStack
              UiDatePicker.date-picker(
                :modelValue="getSelectedDate(filters)"
                @update:modelValue="updateFilters({ year: $event.getFullYear(), month: $event.getMonth() + 1 })"
              )
</template>

<script>
import ApiBilling from "@/api/billing.js";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      reseller: null,
      downloadLink: "",
    };
  },

  computed: {
    headers() {
      return [
        {
          key: "company_name",
          label: "Company Name",
          tooltip: "Company Name",
          sortable: true,
        },
        {
          key: "netvisor_organization_id",
          label: "Business ID",
          tooltip: "Business ID",
          sortable: true,
        },
        {
          key: "invoices_count",
          label: "Total Invoices",
          tooltip: "Total Invoices",
        },
        {
          key: "already_suggested_invoices_count",
          label: "Already Suggested Invoices",
          tooltip:
            "Amount of Invoices with correct account suggested by the Accounting software",
        },
        {
          key: "suggested_invoices_count",
          label: "FR Suggested Invoices",
          tooltip: "Amount of Invoices suggested by Finance.Rocks",
        },
        {
          key: "automatically_correct_invoices_count",
          label: "Automatically correct invoices",
          tooltip: "Total amount of invoices with correctly suggested account",
        },
        {
          key: "automation_perc",
          label: "Automation %",
          tooltip: "Automation %",
        },
        {
          key: "correct_invoices_count",
          label: "FR Correct Invoices",
          tooltip: "FR Correct Invoices",
        },
        {
          key: "correct_invoices_perc",
          label: "FR Correct % of suggested",
          tooltip: "FR Correct % of suggested",
        },
        {
          key: "correct_lines",
          label: "FR Correct Lines",
          tooltip: "FR Correct Lines",
        },
        {
          key: "summ",
          label: "Billable €",
          tooltip: "Billable €",
        },
        {
          key: "total_transfers",
          label: "Total Banktransfers",
          tooltip: "Total Banktransfers",
        },
        {
          key: "correct_transfers",
          label: "FR Correct Banktransfers",
          tooltip: "FR Correct Banktransfers",
        },
        {
          key: "billable_payments",
          label: "Billable €",
          tooltip: "Billable €",
        },
      ];
    },
  },

  watch: {
    "$route.query": {
      handler() {
        this.updateDownloadLink();
      },
    },
  },

  methods: {
    getSelectedDate(filters) {
      if (!filters.year || !filters.month) {
        return null;
      }
      return new Date(filters.year, filters.month - 1);
    },

    updateDownloadLink() {
      let result = `/billing/download?reseller_id=${this.$route.params.id}`;
      const filters = this.$refs.billingTable?.getTableFilters();

      if (filters && filters.year && filters.month) {
        result += `&year=${filters.year}`;
        result += `&month=${filters.month}`;
      }
      this.downloadLink = result;
    },

    getData(params, config) {
      return ApiBilling.FetchCompanies(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: [...resp.data.totals, ...resp.data.companies],
          meta: resp.data.meta,
        };
      });
    },

    async fetchData() {
      const response = await ApiResellers.getReseller(this.$route.params.id);
      this.reseller = response.data.reseller;
    },
  },

  async mounted() {
    await this.fetchData();
    this.updateDownloadLink();
  },
};
</script>

<style lang="scss" scoped>
.date-picker {
  min-width: 200px;
}
</style>
